import { render, staticRenderFns } from "./EditPractitioner.vue?vue&type=template&id=bee252ba&scoped=true"
import script from "./EditPractitioner.vue?vue&type=script&lang=js"
export * from "./EditPractitioner.vue?vue&type=script&lang=js"
import style0 from "./EditPractitioner.vue?vue&type=style&index=0&id=bee252ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee252ba",
  null
  
)

export default component.exports